import { createContext } from "react";

export const ContextTransaction = createContext(null);